module.exports = __webpack_public_path__ + "01_short_gray.c743bb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_short_gray.png
// module id = 86je
// module chunks = 0